import React from 'react';

export default function NotFound() {
  return <>Not Found</>;
}